import styles from './LoadingSpinner.module.css';

const LoadingSpinner = () => {
  return (
    <div className={styles.loadingspinner}>
      {/* TODO: LoadingSpinner component */}
    </div>
  );
};

export default LoadingSpinner;
